// import { getUserPointDetails } from '@/screens/home/action/userDetails';
// import { create } from 'zustand'

// type LoyaltyProps = {
//     coin: number;
//     xp: number;
//     loyaltyData: any
// }

// type LoyaltyAction = {
//     setData: (newData: Partial<LoyaltyProps>) => void
//     fetchLoyalty: () => void
// }

// const useLoyaltyStore = create<LoyaltyProps & LoyaltyAction>((set) => ({
//     coin: 0,
//     xp: 100,
//     loyaltyData: null,
//     setData: (newData) => set((state) => ({ ...state, ...newData })),
//     fetchLoyalty: async () => {
//         set((state) => ({ ...state, loading: true }));
//         try {
//             const data = await getUserPointDetails();
//             set((state) => ({ ...state, xp: Number(data.xp), coin: Number(data.coin), loyaltyData: data, loading: false }));
//         } catch (error: any) {
//             set((state) => ({ ...state, error: error.message, loading: false }));
//         }
//     },
// }))

// export default useLoyaltyStore

import { getUserPointDetails } from '@/screens/home/action/userDetails';
import { create } from 'zustand';

type LoyaltyProps = {
  coin: number;
  xp: number;
  loyaltyData: any;
  loading?: boolean;
  error?: string;
};

type LoyaltyAction = {
  setData: (newData: Partial<LoyaltyProps>) => void;
  fetchLoyalty: () => Promise<void>;
};

const useLoyaltyStore = create<LoyaltyProps & LoyaltyAction>(set => ({
  coin: 0,
  xp: 100,
  loyaltyData: null, // Assuming initial loyaltyData is null or you can set it to an empty object {}
  setData: newData => set(state => ({ ...state, ...newData })),
  fetchLoyalty: async (): Promise<void> => {
    set(state => ({ ...state, loading: true }));
    try {
      const data = await getUserPointDetails();
      set(state => ({
        ...state,
        xp: Number(data.xp),
        coin: Number(data.coin),
        loyaltyData: data,
        loading: false,
      }));
    } catch (error: any) {
      set(state => ({
        ...state,
        error: error.message,
        loading: false,
      }));
    }
  },
}));

export default useLoyaltyStore;
